import { FC } from 'react'

import * as SC from '../styles'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'
import { IconName } from 'ui/components/Icon'

import { handlerServerError } from '@orbit/errors'

import { FooterProps } from './Footer.types'

export const Footer: FC<FooterProps> = ({ data }) => {
  const { id = 0, nextId, previousId, canApprove, canCancel } = data || {}
  const queryClient = useQueryClient()

  const { mutate: cancelSAR, isPending: isCanceling } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.patch(Request.urls.bank.bsaSarCancel, opts),
    onError: (error) => {
      handlerServerError(error)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sar-details'] })
    }
  })

  const { mutate: approveSAR, isPending: isApproving } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.patch(Request.urls.bank.bsaSarApprove, opts),
    onError: (error) => {
      handlerServerError(error)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sar-details'] })
    }
  })

  return (
    <SC.Box>
      <ButtonGroup margin="small">
        {previousId && (
          <SC.PrevLink to={routes.bank.bsa.sar.details} params={{ id: previousId.toString() }}>
            <SC.IconButton face="secondary">
              <div>
                <SC.StyledIcon name={IconName.ARROW_PREVIOUS} />
                Prev
              </div>
            </SC.IconButton>
          </SC.PrevLink>
        )}
        {nextId && (
          <Link to={routes.bank.bsa.sar.details} params={{ id: nextId.toString() }}>
            <SC.IconButton face="secondary">
              <div>
                <SC.StyledIcon name={IconName.ARROW_NEXT} /> Next
              </div>
            </SC.IconButton>
          </Link>
        )}
      </ButtonGroup>

      <ButtonGroup margin="small">
        {canCancel && (
          <Button face="secondary" disabled={isCanceling} onClick={() => cancelSAR({ id })}>
            Cancel SAR
          </Button>
        )}
        {canApprove && (
          <Button face="primary" disabled={isApproving} onClick={() => approveSAR({ id })}>
            Approve
          </Button>
        )}
      </ButtonGroup>
    </SC.Box>
  )
}
